// extracted by mini-css-extract-plugin
export var layoutContainer = "_9l-0";
export var layoutContainerNoRounding = "_9l-6";
export var layoutContainerOpen = "_9l-5";
export var layoutContainerResizing = "_9l-1";
export var mainContent = "_9l-2";
export var resizeDivider = "_9l-3";
export var slidePanel = "_9l-4";